// extracted by mini-css-extract-plugin
export default {"root":"about_root__VoTQE"};